export class Page {
  size = 10;
  totalElements = 0;
  totalPages = 0;
  pageNumber = 0;
  hasFilter = false;
  filter = "";
}

export class MedicationsSuppliesSummaryListViewModel {
  medicationsSupplies: Array<MedicationsSuppliesSummary>;
  page = new Page();
  isOffline: boolean;
}

export class MedicationsSuppliesSummary {
  id: string;
  name: string;
  instructions: string;
  defaultQuantity: number;
  minimumQuantity: string;
  price: string;
  code: string;
  disabled: boolean;
  hasEqProtectDiscount: boolean;
  showOnEQProtect: boolean;
  showOnOverview: boolean;
  timePeriodType: string;
  medicationSupplyCategory: string;
  isControlledSubstance: boolean;
  isShownOnMedicationsTab: boolean;
  isInventory: boolean;
  causesDeath: boolean;
  category: string;
  inventoryBucketId: string;
  inventoryBucketName: string;
  inventoryConversionFactor: number;
  saleItemId: string;
  saleItemName: string;
  purchasePrice: number;
  hideNonBillingCode: boolean;
  minimumCost: number | null;
}

export const DEA_SCHEDULES = [
  { value: "None", label: "None" },
  { value: "I", label: "Schedule I" },
  { value: "II", label: "Schedule II" },
  { value: "III", label: "Schedule III" },
  { value: "IV", label: "Schedule IV" },
  { value: "V", label: "Schedule V" },
];

// One row of the append-only DEA schedule history table. The backend
// returns this shape from GET api/MedicationsSupplies/{id}/DeaScheduleHistory
// (the controller's anonymous projection in MedicationsSuppliesController.cs).
// EffectiveDate is a .NET DateOnly serialized as a "YYYY-MM-DD" string.
// CreatedTimestamp / DisabledTimestamp are .NET DateTimeOffset serialized as
// ISO 8601 strings.
export interface DeaScheduleHistoryEntry {
  id: string;
  medicationsSuppliesId: string;
  deaSchedule: string;
  effectiveDate: string;
  isDisabled: boolean;
  disabledTimestamp: string | null;
  disabledByUserId: string | null;
  createdTimestamp: string;
  createdByUserId: string | null;
}

// Wrapped GET response from api/MedicationsSupplies/{id}/DeaScheduleHistory.
// `currentEntryId` is the server resolver's pick — the entry the rest of the
// app considers active right now in the caller's calendar (the X-Client-TimeZone
// header, defaulting to Pacific). Null when no qualifying row exists.
export interface DeaScheduleHistoryResponse {
  entries: DeaScheduleHistoryEntry[];
  currentEntryId: string | null;
}

export const MEDICATION_CATEGORIES = [
  "Other",
  "BandageMaterial",
  "ControlledDrugs",
  "Eyes",
  "Fluids",
  "House",
  "Injectables",
  "IVShelf",
  "Orals",
  "Outside",
  "Plasma",
  "StorageShed",
  "Supplies",
  "Suture",
  "Topicals",
  "Vaccinations",
  "Wormers",
];
